module.exports = __webpack_public_path__ + "img/arrow-prev-white.62b01742.svg";